/**
 * Token Storage Service
 * Centralizes token management to allow easy migration from localStorage to httpOnly cookies
 * or other storage mechanisms in the future.
 */

export const tokenStorage = {
  getToken: (): string | null => {
    return null; // Token is now in httpOnly cookie
  },

  setToken: (_token: string): void => {
    // No-op: Token is set by server via Set-Cookie header
  },

  removeToken: (): void => {
    // No-op: Server clears cookie on logout
  },

  getRefreshToken: (): string | null => {
    return null;
  },

  setRefreshToken: (_token: string): void => {
    // No-op
  },

  removeRefreshToken: (): void => {
    // No-op
  },

  clearAll: (): void => {
    // No-op
  },
};
